import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { trackMixpanel } from 'portal/store/mixpanel/actions'

export function useMixpanelEvents() {
  const dispatch = useDispatch()

  return {
    trackNavGroupClick: useCallback(
      (projectId, accountId, groupName, isOpen) => {
        dispatch(
          trackMixpanel(
            `frontend_navgroup_${groupName}_${isOpen ? 'opened' : 'closed'}`,
            {
              project_id: projectId,
              account_id: accountId
            }
          )
        )
      },
      [dispatch]
    ),
    trackDashboardEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_dashboard_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    ),
    trackDashboardProEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_dashboard_pro_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    ),
    trackEventsPageEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_events_page_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    ),
    trackAlertsWasteCompliancePageEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_alerts_waste_compliance_page_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    ),
    trackAlertsMaterialCertificationsPageEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_alerts_material_certifications_page_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    ),
    trackAlertsQualityAssurancePageEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_alerts_quality_assurance_page_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    ),
    trackAlertsSubmissionIssuesPageEventClick: useCallback(
      (projectId, accountId) => {
        dispatch(
          trackMixpanel('frontend_alerts_submission_issues_page_click', {
            project_id: projectId,
            account_id: accountId
          })
        )
      },
      [dispatch]
    )
  }
}
